import {
  LabelInput,
  EntryTypeSelect,
  RequiredToggle,
  HideOnPdfToggle,
  StandardDesignConfig,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

// does not support Read Only or default value, so no hide on form either
export const CheckboxStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  RequiredToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
